<template>
    <div>
        <el-drawer
            :visible.sync="show"
            direction="btt"
            :show-close="false"
            :with-header="false"
            append-to-body
            custom-class="other-filter-drawer"
            size="400"
            @close="onClose"
            style="width:100%;"
        >
            <template #default>
                <div class="c-var m-confirm-ok">
                    <div class="u-content">
                        <div class="u-icon">
                            <svg width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M104.048 83.182l-33.922-58.91a11.15 11.15 0 00-19.248 0l-33.922 58.91a10.648 10.648 0 000 10.749 10.981 10.981 0 009.624 5.504h67.844a10.981 10.981 0 009.616-5.504 10.64 10.64 0 00.008-10.749zm-8.068 6.09a1.73 1.73 0 01-1.552.853H26.58a1.73 1.73 0 01-1.552-.853 1.381 1.381 0 010-1.447l33.922-58.91a1.85 1.85 0 013.104 0l33.918 58.91a1.38 1.38 0 01.008 1.447zM55.847 63.748V51.335a4.655 4.655 0 119.31 0v12.413a4.655 4.655 0 01-9.31 0zm10.861 15.516a6.206 6.206 0 11-12.413 0 6.206 6.206 0 0112.413 0z" fill="currentColor"/></svg>
                        </div>
                        确定要将其设为{{ current ? "未" : "已" }}完成吗
                    </div>
                    <div class="m-op">
                        <button class="u-confirm" @click="confirmResult">
                            确认
                        </button>
                    </div>
                </div>
            </template>
        </el-drawer>
    </div>
</template>

<script>

export default {
    name: "ConfirmOkDrawer",
    components: { },
    emits: ["update:visible","confirm"],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        current: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
        }
    },
    watch:{
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            }
        },

    },
    methods: {
        onClose() {
            this.show = false;
        },
        confirmResult(){
            this.$emit("confirm")
            this.onClose();
        }
    },
}
</script>

<style lang="less">

.other-filter-drawer{
    border-radius: 20px 20px 0px 0px;
    overflow: hidden;
    background: transparent;
}

.m-confirm-ok {
    display: flex;
    flex-direction: column;
    background-color: #24292E;
    padding: 20px;
    min-height: 260px;
    position: relative;
    width: 100%;

    .u-content{
        display: flex;
        align-items: center;
        flex-direction:  column;
        width: 100%;

        .u-icon{
            width: 120px;
            height: 120px;
            color: rgba(255, 255, 255, 0.40);
        }

        color: rgba(255, 255, 255, 0.40);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */

    }

    .m-op {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        padding: 20px 12px 30px;
        gap: 20px;
        background-color: #24292E;

        button {
            color:  rgba(28, 28, 28, 0.40);

            /* 16 Bold */
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 150% */

            border-radius: var(--12, 12px);
            padding: var(--12, 12px) var(--16, 16px);
            border: none;

            &.u-reset {
                display: flex;
                justify-content: center;
                align-items: center;
                color: rgba(255, 255, 255, 0.40);
                background: rgba(255, 255, 255, 0.05);

                &.active{
                    color: rgba(255, 255, 255, 1);
                }
            }

            &.u-confirm {
                color: rgba(255, 255, 255, 0.40);

                /* 16 Bold */
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; /* 150% */
                flex: 1;

                border-radius: var(--12, 12px);
                background: rgba(255, 255, 255, 0.05);

                &.active{
                    color: #000;
                    background: #FEDAA3;
                }
            }
        }
    }


}
</style>
